import { ThemeConfig } from "../config/theme.config";
import { Box, Typography } from "@mui/material";
import ScrollToTop from "../wrapper/scrollToTop";
import { Footer } from "../components";

export const PrivacyScreen = () => {
   return (
      <ThemeConfig>
         <ScrollToTop>
            <Box sx={{ px: { xs: 1, md: 15, lg: 30 } }}>
               <Box
                  sx={{
                     display: "flex",
                     flexDirection: { xs: "column", md: "row" },
                     alignItems: { xs: "center", md: "auto" },

                     py: 5,
                     mb: 2,
                  }}
               >
                  <Box sx={{ display: "flex", flex: 1 }}>
                     <Box
                        component={"img"}
                        src={"https://images-lecosy.s3.us-west-2.amazonaws.com/assets/logo-lecosy.png"}
                        sx={{ display: "flex", height: 70 }}
                     />
                  </Box>
                  <Typography
                     color={"primary"}
                     variant="h4"
                     sx={{ display: "flex", flex: 2, alignItems: "center", fontFamily: "Bold", textAlign: "center" }}
                  >
                     Políticas de privacidad
                  </Typography>
               </Box>
               <Box sx={{ px: { xs: 3, md: 0 }, py: 8 }}>
                  <Typography align="justify" lineHeight={1.75}>
                     <strong>LECOSY, S.A.P.I. DE C.V.,</strong> con domicilio en Calle General José María Yañez número
                     8, Colonia San Benito, C.P. 83190, Hermosillo, Sonora, es responsable de los datos personales que
                     ha recabado o que recabe de sus clientes o de cualquier otra persona física o moral, del uso que se
                     dé a los mismos y de su debida protección. En este contexto y conforme a lo dispuesto por los
                     artículos 15 y 16 de la Ley Federal de Protección de Datos Personales en Posesión de los
                     Particulares (así como de los artículos relativos y aplicables de su Reglamento) se hace de su
                     conocimiento, mediante el presente documento, las características y finalidades del tratamiento que
                     se dará a sus datos personales.
                     <br />
                     <br />
                     <strong>¿Cómo recaba LECOSY, S.A.P.I. DE C.V. los datos personales:</strong>
                     <br />
                     Sus datos personales pueden ser recabados por los siguientes medios: de forma directa y personal en
                     nuestras oficinas ubicadas en el domicilio antes señalado; por vía telefónica; así como por medios
                     electrónicos, incluyendo correo electrónico, nuestra página web, formularios en línea y
                     aplicaciones oficiales
                     <br />
                     <br />
                     <strong>Finalidad de los datos personales.</strong>
                     <br />
                     Para llevar a cabo las finalidades descritas en el presente Aviso de Privacidad, utilizaremos los
                     siguientes datos:
                     <br />
                     <br />
                     Los datos personales serán recopilados única y exclusivamente para: <strong>I.-</strong>{" "}
                     Recopilación de información necesaria del cliente o prospecto para dar inicio a la prestación de
                     nuestros servicios, conocer sus necesidades de productos o servicios y estar en posibilidad de
                     ofrecerle los que más se adecuen a sus preferencias, así como al seguimiento a cualquier relación
                     contractual entre el titular de los datos personales y nuestra empresa, <strong> II.-</strong>{" "}
                     Realizar gestiones internas necesarias para la relación comercial, <strong>III.-</strong> Fines
                     fiscales y/o de facturación, <strong>IV.-</strong> Fines estadísticos, <strong>V.-</strong> Proveer
                     servicios y productos requeridos por usted. <strong>VI.-</strong> Seguridad Integral y patrimonial.{" "}
                     <strong>VII.-</strong> Cualquier finalidad análoga o compatible con las anteriores.
                     <br />
                     <br />
                     <strong>¿Qué datos personales utilizaremos?</strong>
                     <br />
                     <br />
                     <strong>DATOS DE IDENTIFICACIÓN DE PERSONAS FÍSICAS:</strong> Nombre, nacionalidad, fecha y lugar
                     de nacimiento, edad, género, estado civil, domicilio, ocupación, identificación oficial vigente,
                     folio o número de identificación, Registro Federal de Contribuyentes (RFC), Clave Única de Registro
                     de Población (CURP), firma, teléfono particular, teléfono celular y correo electrónico.
                     <br />
                     <br />
                     <strong>DATOS LABORALES DE PERSONAS FÍSICAS:</strong> Puesto desempeñado, domicilio de trabajo,
                     teléfono, correo electrónico de trabajo, referencias laborales y personales con Nombre, domicilio,
                     teléfono y relación vinculante.
                     <br />
                     <br />
                     <strong>DATOS GENERALES DE PERSONAS MORALES:</strong> Razón social, nombre del apoderado y/o
                     representante legal, domicilio fiscal y en su caso, aquel que sea señalado para oír y recibir
                     notificaciones, actividad económica, Registro Federal de Contribuyentes (RFC), código postal,
                     correo electrónico institucional y teléfono fijo.
                     <br />
                     <br />
                     <strong>DOCUMENTOS PÚBLICOS EN GENERAL:</strong> Identificaciones oficiales, escrituras públicas de
                     actas constitutivas o asambleas, poderes, entre otras, folio del Registro Público de la Propiedad y
                     Comercio, oficios de entidades gubernamentales, constancia de situación fiscal, comprobante de
                     domicilio, etc.
                     <br />
                     <br />
                     <strong>DOCUMENTOS PRIVADOS EN GENERAL:</strong> Identificaciones oficiales, escrituras públicas de
                     actas constitutivas o asambleas, poderes, entre otras, folio del Registro Público de la Propiedad y
                     Comercio, oficios de entidades gubernamentales, constancia de situación fiscal, comprobante de
                     domicilio, etc.
                     <br />
                     <br />
                     <strong>DATOS PATRIMONIALES Y FINANCIEROS: </strong>
                     Datos patrimoniales y financieros de sus clientes, proveedores, empleados, tales como información
                     de cuentas bancarias, datos de tarjetas de crédito o débito para el procesamiento de pagos,
                     historial de pagos y adeudos, comprobantes de transferencias, percepciones salariales, deducciones,
                     constancia de situación fiscal así como su régimen fiscal. Estos datos serán utilizados
                     exclusivamente para fines de facturación, pago de servicios, cumplimiento de obligaciones
                     contractuales, administración de nómina, control interno y demás finalidades compatibles con la
                     relación jurídica existente y correspondiente.
                     <br />
                     <br />
                     <strong>DATOS RECABADOS POR CÁMARAS DE SEGURIDAD:</strong> Imagen facial, características físicas
                     visibles, forma de vestir, movimientos dentro del inmueble, así como, en su caso, grabaciones de
                     voz y sonidos ambientales. Adicionalmente, datos contextuales como fecha, hora, ubicación, y firma
                     digital.
                     <br />
                     <br />
                     Además de los datos personales previamente mencionados, y para el cumplimiento de las finalidades
                     establecidas en el presente Aviso de Privacidad, <strong>LECOSY, S.A.P.I. DE C.V.</strong> podrá
                     tratar datos personales considerados como sensibles, específicamente datos biométricos, tales como
                     huellas dactilares e imágenes fotográficas de los titulares. Dichos datos serán recabados, tratados
                     y resguardados bajo medidas de seguridad técnicas, administrativas y físicas que garanticen su
                     confidencialidad, integridad y disponibilidad, solicitando en todo caso el consentimiento expreso,
                     libre, informado y por escrito del titular antes de su tratamiento.
                     <br />
                     <br />
                     <strong>Tratamiento de datos dentro del software.</strong>
                     <br />
                     <br />
                     <strong>LECOSY, S.A.P.I. DE C.V.</strong> manifiesta que el tratamiento de los datos personales que
                     recaba se limita a aquellos necesarios para la relación comercial, administrativa, fiscal y de
                     soporte con sus clientes, en los términos señalados en este Aviso de Privacidad.
                     <br />
                     <br />
                     El uso, captura, almacenamiento, administración y tratamiento de los datos personales que los
                     clientes ingresen, almacenen o procesen mediante el software licenciado por{" "}
                     <strong>LECOSY, S.A.P.I. DE C.V.</strong> es exclusiva responsabilidad del cliente titular de la
                     licencia en su calidad de responsable del tratamiento de dichos datos.{" "}
                     <strong>LECOSY, S.A.P.I. DE C.V.</strong> no accede a dicha información, salvo cuando resulte
                     indispensable para brindar soporte técnico o mantenimiento, y únicamente bajo instrucción del
                     cliente por escrito con (5) cinco días de anticipación. En esos casos actuará como encargado del
                     tratamiento, aplicando las medidas de seguridad y confidencialidad correspondientes.
                     <br />
                     <br />
                     En consecuencia, el cliente se obliga a cumplir con la legislación aplicable en materia de
                     protección de datos personales, eximiendo a <strong>LECOSY, S.A.P.I. DE C.V.</strong> de cualquier
                     responsabilidad derivada del uso indebido, acceso no autorizado o tratamiento ilícito de los datos
                     que gestione dentro del software.
                     <br />
                     <br />
                     <strong>Uso de cámaras de vigilancia.</strong>
                     <br />
                     <br />
                     Le informamos que por motivos de seguridad nuestras instalaciones cuentan con sistemas de
                     videovigilancia. Las imágenes y sonidos captados serán tratados como datos personales en los
                     términos de la Ley. Las grabaciones se almacenan por un período máximo de 15 días naturales y no se
                     utilizarán para fines distintos a los aquí señalados, salvo que se requiera su conservación por
                     mandamiento legal o investigación interna debidamente justificada
                     <br />
                     <br />
                     <strong>Transferencia de datos personales.</strong>
                     <br />
                     Le informamos que los datos personales recabados por <strong>LECOSY, S.A.P.I. DE C.V.</strong>no
                     serán compartidos, ni transferidos a terceros, salvo en los siguientes casos: <strong>I.-</strong>
                     Cuando así lo soliciten autoridades federales o locales; <strong>II.-</strong> Aquellos respecto de
                     los cuales usted hubiera dado su consentimiento en forma previa. Dichos datos personales son y/o
                     serán utilizados solamente por el personal autorizado al efecto y en relación con las finalidades
                     antes mencionadas (atendiendo en todo momento a los principios de protección de datos establecidos
                     por Ley Federal de Protección de Datos Personales en Posesión de los Particulares).
                     <br />
                     <br />
                     <strong>Derechos ARCO.</strong>
                     <br />
                     De conformidad con lo establecido en la Ley Federal de Protección de Datos Personales en Posesión
                     de los Particulares, usted tiene derecho a ejercer en cualquier momento sus derechos ARCO, que
                     corresponden a Acceso, Rectificación, Cancelación y Oposición respecto al tratamiento de sus datos
                     personales y/o sensibles proporcionados a <strong>LECOSY, S.A.P.I. DE C.V.</strong> Estos derechos
                     le permiten, entre otras cosas, oponerse al uso de sus datos o revocar el consentimiento
                     previamente otorgado, siempre que no exista una disposición legal que lo impida.
                     <br />
                     Para ejercer cualquiera de estos derechos, puede enviar su solicitud a la dirección de correo
                     electrónico <a href="mailto: administrador@lecosy.com.mx">administrador@lecosy.com.mx </a>
                     presentarla por escrito en el domicilio de la empresa o en las instalaciones de{" "}
                     <strong>LECOSY, S.A.P.I. DE C.V.</strong> al Departamento de Tratamiento de Datos Personales,
                     responsable de resguardar dicha información.
                     <br />
                     De acuerdo con el artículo 31 de la Ley, se dará respuesta a su solicitud en un plazo máximo de 20
                     (veinte) días hábiles contados a partir de su recepción. En caso de ser procedente, su solicitud
                     será atendida dentro de los 15 (quince) días hábiles siguientes a la fecha en que se le notifique
                     la resolución.
                     <br />
                     <br />
                     <strong>Procedimiento para ejercer los derechos ARCO</strong>
                     <br />
                     El titular de los datos personales o su representante legal podrá presentar una solicitud, ya sea
                     de forma libre o por medio de nuestro formato, el cual podrá solicitar al correo electrónico
                     <a href="mailto: administrador@lecosy.com.mx"> administrador@lecosy.com.mx </a> que deberá contener
                     lo siguiente:
                     <br />
                     <ul>
                        <li>
                           Nombre completo del titular y domicilio o medio alternativo para recibir notificaciones.
                        </li>
                        <li>
                           Copia de un documento que acredite la identidad del titular o, en su caso, la representación
                           legal correspondiente.
                        </li>
                        <li>
                           Descripción clara y precisa de los datos personales sobre los que desea ejercer alguno de sus
                           derechos, salvo en el caso del derecho de acceso.
                        </li>
                        <li>Especificación del derecho ARCO que se desea ejercer.</li>
                        <li>
                           Cualquier otro elemento o documento que facilite la localización de los datos personales.
                        </li>
                     </ul>
                     <br />
                     Asimismo, en caso de que sus datos sean incorrectos, inexactos, incompletos o no estén
                     actualizados, podrá solicitar su rectificación a través de los medios de contacto previamente
                     indicados. Esto nos permitirá mantener una base de datos precisa, completa y vigente.
                     <br />
                     <br />
                     <strong>Revocación de consentimiento para el uso de sus datos personales</strong>
                     <br />
                     Usted puede revocar el consentimiento que, en su caso, nos haya otorgado para el tratamiento de sus
                     datos personales. Sin embargo, es importante que tenga en cuenta que no en todos los casos podremos
                     atender su solicitud o concluir el uso de forma inmediata, ya que es posible que por alguna
                     obligación legal requiramos seguir tratando sus datos personales. Asimismo, usted deberá considerar
                     que para ciertos fines, la revocación de su consentimiento implicará que no le podamos seguir
                     prestando el servicio que nos solicitó, o la conclusión de su relación con nosotros.
                     <br />
                     Para revocar su consentimiento deberá ponerse en contacto con nuestro Departamento de Privacidad,
                     directamente en el domicilio de <strong>LECOSY, S.A.P.I. DE C.V.</strong> siguiendo el mismo
                     procedimiento para los derechos ARCO.
                     <br />
                     <br />
                     <strong>El uso de tecnologías de rastreo en nuestro portal de internet.</strong>
                     <br />
                     En relación con el uso de tecnologías de rastreo en nuestro portal de Internet le informamos que en
                     nuestra página de Internet utilizamos cookies, web beacons y otras tecnologías a través de las
                     cuales es posible monitorear su comportamiento como usuario de Internet, brindarle un mejor
                     servicio y experiencia de usuario al navegar en nuestra página, así como ofrecerle nuevos productos
                     y servicios basados en sus preferencias.
                     <br />
                     Los datos personales que obtenemos de estas tecnologías de rastreo son los siguientes:{" "}
                     <strong>I.-</strong> Horario de navegación, <strong>II.-</strong> Tiempo de navegación en nuestra
                     página de Internet, <strong>III.-</strong> Secciones consultadas, <strong>IV.-</strong> Páginas de
                     Internet accedidas previo a la nuestra; Asimismo, le informamos que sus datos personales que se
                     obtienen a través de estas tecnologías no son compartidas con terceros.
                     <br />
                     Estas tecnologías podrán deshabilitarse siguiendo los siguientes pasos: <strong>1.</strong> Acceder
                     a nuestra página de Internet, sección “Términos y condiciones del sitio”, subsección “Cookies”;{" "}
                     <strong>2.</strong> Dar clic en la subsección “Cookies”; <strong>3.</strong> Leer el mensaje de
                     advertencia sobre la des habilitación de cookies, y <strong> 4. </strong>
                     Dar clic en la leyenda de activar el mecanismo de des habilitación de cookies.
                     <br />
                     <br />
                     <strong>Consentimiento.</strong>
                     <br />
                     Al proporcionar sus datos personales a LECOSY, S.A.P.I. DE C.V., usted manifiesta su consentimiento
                     para que los mismos sean tratados conforme a lo establecido en el presente Aviso de Privacidad. El
                     tratamiento incluye, de manera enunciativa más no limitativa, la obtención, uso, almacenamiento y
                     transferencia de sus datos para las finalidades señaladas.
                     <br />
                     En caso de que <strong>LECOSY, S.A.P.I. DE C.V.</strong> recabe datos personales, financieros,
                     patrimoniales o sensibles, se solicitará su consentimiento expreso y por escrito, conforme a lo
                     dispuesto en el artículo 8 de la Ley Federal de Protección de Datos Personales en Posesión de los
                     Particulares.
                     <br />
                     <strong>LECOSY, S.A.P.I. DE C.V.,</strong> y todo su personal reconocemos la importancia de un
                     adecuado tratamiento para sus datos personales y, como consecuencia de ello, se han implementado
                     diversos controles y medidas de seguridad tales como Políticas de Privacidad, Guía para el borrado
                     seguro de datos personales, implementación del sistema de gestión de seguridad de datos personales,
                     que permiten que dichos datos personales conserven su carácter confidencial y previenen tanto un
                     acceso o uso no autorizado como posibles daños, pérdidas o alteraciones a los mismos.
                     <br />
                     No obstante, si usted tiene cualquier duda o inquietud acerca de nuestras prácticas de privacidad
                     le pedimos se ponga en contacto con nosotros a través de la dirección electrónica
                     <a href="mailto: administrador@lecosy.com.mx"> administrador@lecosy.com.mx </a> o bien acudir al
                     departamento de tratamiento de datos personales quien es el responsable de guardar y custodiar la
                     información de datos personales. De igual forma, si usted no desea recibir cualquier aviso, le
                     solicitamos, lo haga de nuestro conocimiento.
                     <br />
                     <br />
                     <strong>Cambios del presente aviso de privacidad.</strong>
                     <strong>LECOSY, S.A.P.I. DE C.V.,</strong> se reserva el derecho de actualizar y/o modificar los
                     términos del presente aviso de privacidad en cualquier momento, en cuyo caso, comunicará dicha
                     situación en su página de Internet{" "}
                     <a href="mailto: administrador@lecosy.com.mx"> administrador@lecosy.com.mx </a> o mediante un
                     correo electrónico a la dirección que usted nos haya proporcionado.
                     <br />
                     Habiéndose puesto a su disposición el presente aviso de privacidad y usted no manifieste su derecho
                     de oposición al respecto, se considerará por Ley que usted le otorga a LECOSY, S.A.P.I. DE C.V.,
                     consentimiento tácito, para que podamos llevar a cabo recopilación, tratamiento y generación de
                     datos personales del titular bajo los lineamientos establecidos en el presente instrumento jurídico
                     y según lo establecido por los artículos 2 fracción IV, V, VI 7, 8, 11,12, 13 y 17 de la Ley;
                     asimismo, cabe hacer mención que sin la necesidad de su consentimiento podremos allegarnos y/o
                     hacer tratamiento de sus datos personales que figuren en fuentes del dominio público según lo
                     dispuesto en los artículos 9 fracción IV y 36 fracción IV de la Ley.
                  </Typography>
                  <Typography sx={{ textAlign: "right" }}>
                     <br />
                     <br />
                     Fecha de modificación 25 de septiembre del año 2025.
                  </Typography>
               </Box>
            </Box>
            <Footer />
         </ScrollToTop>
      </ThemeConfig>
   );
};
